import React from "react";
import SalePageMobile from "./SalePageMobile";

const SalePageWrapper: React.FC = React.memo(() => {
  try {
    return <SalePageMobile />;
  } catch (error) {
    console.error('Error loading SalePageMobile:', error);
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>POS System</h1>
        <p>Có lỗi xảy ra khi tải trang</p>
        <p>Error: {error instanceof Error ? error.message : 'Unknown error'}</p>
      </div>
    );
  }
});

export default SalePageWrapper; 